import { openAPIClient } from '@/services/httpServices/openApiClient';

import type {
  CreateDeeplinkResponse,
  CreateDeeplinkServiceConfig,
  GetSpaceLanguagesResponse,
  GetSpaceLanguagesServiceConfig,
  GetUserAddonsResponse,
  GetUserAddonsServiceConfig,
  GetVoicesResponse,
  GetVoicesServiceConfig,
} from './types';

export async function createDeeplinkService({
  httpRequestConfig,
  params,
}: CreateDeeplinkServiceConfig): Promise<CreateDeeplinkResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (!params) {
    throw new Error('Params are required');
  }

  const response = await client.POST(
    '/v1/auth/general/{spaceId}/createDeeplink',
    {
      params: {
        path: {
          spaceId: httpRequestConfig.space as string,
        },
      },
      body: params.body,
    },
  );

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function getUserAddonsService({
  httpRequestConfig,
}: GetUserAddonsServiceConfig): Promise<GetUserAddonsResponse> {
  const client = await openAPIClient(httpRequestConfig);

  const response = await client.GET('/v1/auth/general/{spaceId}/userAddons', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function getSpaceLanguagesService({
  httpRequestConfig,
}: GetSpaceLanguagesServiceConfig): Promise<GetSpaceLanguagesResponse> {
  const client = await openAPIClient(httpRequestConfig);

  const response = await client.GET('/v1/auth/general/{spaceId}/spaceLanguages', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function getVoicesService({
  httpRequestConfig,
  params,
}: GetVoicesServiceConfig): Promise<GetVoicesResponse> {
  const client = await openAPIClient(httpRequestConfig);

  const response = await client.GET('/v1/auth/general/voices', {
    params: {
      query: params?.query,
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}
